import { when } from "mobx";
import defaultSessionStore from "../session/SessionStore"
import config from "../../config";

/**
 * The WebSocket implementation for Legacy Workflow Notifications
 */
class WorkflowNotificationsSocket {

  messageCallback = () => {}

  constructor(sessionStore) {
    this.session = sessionStore || defaultSessionStore
    this.socket = null

    when(() => {
      return this.session.sessionLoaded
    }).then(() => {
      this.initializeSocket()
    })
  }

  onMessage(messageCallback) {
    this.messageCallback = messageCallback;
  }

  initializeSocket() {
    const baseUrl = config.apiSocketUrl;
    this.socket = new WebSocket(`${baseUrl}/user/notificationSocket`)
    this.socket.addEventListener('open', (event) => {
      // authorize
      // TODO make this a mobx store or something
      const token = window.sessionStorage.ssoToken || window.localStorage.token
      this.socket.send(JSON.stringify({authorization: token}))
    })

    this.socket.addEventListener('message', (event) => {
      this.messageCallback(JSON.parse(event.data))
    })

    this.socket.addEventListener('close', (event) => {
      setTimeout(() => this.initializeSocket(), 5000)
    })
  }
}

export default WorkflowNotificationsSocket
